import axios from 'axios';
import store from '../../store/index';

export default {
	load(showDeleted, limit, offset) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/apikeys?deleted=${showDeleted}&limit=${limit}&offset=${offset}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},

	getAPIKey(id) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/apikeys/${id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},

	createAPIKey(comment) {
		return axios.post(
			`${store.state.tenant.tenant?.name}/api/apikeys`,
			{ comment: comment },
			{
				headers: {
					Authorization: `Bearer ${store.state.auth.token}`,
				},
			}
		);
	},

	editAPIKey(APIKey) {
		return axios.patch(
			`${store.state.tenant.tenant?.name}/api/apikeys/${APIKey.id}`,
			{ comment: APIKey.comment, deleted: APIKey.deleted },
			{
				headers: {
					Authorization: `Bearer ${store.state.auth.token}`,
				},
			}
		);
	},

	deleteAPIKey(APIKey) {
		return axios.delete(`${store.state.tenant.tenant?.name}/api/apikeys/${APIKey.id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},

	getAPIKeyPermissions(id) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/apikeys/${id}/permissions`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	updateAPIKeyPermissions(permissions, id) {
		return axios.patch(`${store.state.tenant.tenant?.name}/api/apiKeys/${id}/permissions`, permissions, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},

	loadPermissions() {
		return axios.get(`${store.state.tenant.tenant?.name}/api/permissions`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
